// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { Sun, Moon } from "lucide-react";
// import { InlineWidget } from "react-calendly";
// import ChatBot from "./ChatBot";

// const Header = () => {
//   const [theme, setTheme] = useState(null);
//   const [menuOpen, setMenuOpen] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();

//   // Initialize theme
//   useEffect(() => {
//     const savedTheme = localStorage.getItem("theme");
//     if (savedTheme) {
//       setTheme(savedTheme);
//       document.documentElement.classList.toggle("dark", savedTheme === "dark");
//     } else {
//       const prefersDark = window.matchMedia(
//         "(prefers-color-scheme: dark)"
//       ).matches;
//       setTheme(prefersDark ? "dark" : "light");
//       document.documentElement.classList.toggle("dark", prefersDark);
//     }
//   }, []);

//   // Disable scroll when mobile menu is open
//   useEffect(() => {
//     document.body.style.overflow = menuOpen ? "hidden" : "";
//   }, [menuOpen]);

//   const toggleTheme = () => {
//     const newTheme = theme === "dark" ? "light" : "dark";
//     setTheme(newTheme);
//     localStorage.setItem("theme", newTheme);
//     document.documentElement.classList.toggle("dark", newTheme === "dark");
//   };

//   const toggleMenu = () => setMenuOpen((prev) => !prev);

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth >= 1024) {
//         setMenuOpen(false);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     handleResize();

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Navigation handler
//   const handleNavigation = (e, item) => {
//     e.preventDefault();

//     if (item.name === "Contact Us") {
//       const target = document.getElementById("contact-us");
//       if (target) {
//         target.scrollIntoView({ behavior: "smooth" });
//       } else {
//         navigate("/", { state: { scrollTo: "contact-us" } });
//       }
//       setMenuOpen(false);
//       return;
//     }

//     if (item.name === "Blogs") {
//       if (location.pathname === "/" || location.pathname === "/home") {
//         const target = document.getElementById("blogs");
//         if (target) target.scrollIntoView({ behavior: "smooth" });
//       } else {
//         navigate("/blogs");
//       }
//       setMenuOpen(false);
//       return;
//     }

//     if (location.pathname === "/" || location.pathname === "/home") {
//       const target = document.getElementById(item.scrollTo);
//       if (target) target.scrollIntoView({ behavior: "smooth" });
//     } else {
//       navigate("/", { state: { scrollTo: item.scrollTo } });
//     }

//     setMenuOpen(false);
//   };

//   useEffect(() => {
//     if (location.state?.scrollTo) {
//       const sectionId = location.state.scrollTo;
//       setTimeout(() => {
//         const target = document.getElementById(sectionId);
//         if (target) target.scrollIntoView({ behavior: "smooth" });
//       }, 400);
//       window.history.replaceState({}, document.title);
//     }
//   }, [location]);

//   const [IsFormOpenFor_bookCall, setIsFormOpenFor_bookCall] = useState(false);

//   const openForm1 = () => {
//     setIsFormOpenFor_bookCall(true);
//     setMenuOpen(false);
//   };

//   const closeForm1 = () => {
//     setIsFormOpenFor_bookCall(false);
//   };

//   return (
//     <>
//       <header
//         className={`grid grid-cols-2 lg:grid-cols-[20%_50%_20%] items-center justify-between px-5 h-16
//         bg-white/10 dark:bg-black/20 backdrop-blur-sm border border-transparent dark:border-transparent
//         text-black dark:text-white transition-colors duration-300 fixed top-5 left-5 right-5 z-50 rounded-xl
//         ${
//           !menuOpen
//             ? "shadow-custom dark:shadow-white border border-white/20 dark:border-white/10"
//             : ""
//         }`}
//       >
//         {/* Logo */}
//         <a href="/Home">
//           <img
//             src={
//               theme === "light"
//                 ? "../assets/init_logoBlack.png"
//                 : "../assets/init_logoWhite.png"
//             }
//             alt="Logo"
//             className="h-11"
//           />
//         </a>

//         {/* Desktop Links */}
//         <div className="hidden lg:block">
//           <div className="flex justify-center text-sm space-x-5 xl:space-x-7">
//             <a
//               href="/"
//               onClick={(e) =>
//                 handleNavigation(e, {
//                   name: "Home",
//                   path: "/",
//                   scrollTo: "home",
//                 })
//               }
//               className="relative inline-block group hover:text-teal-600"
//             >
//               Home
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>

//             <a
//               href="/home"
//               onClick={(e) =>
//                 handleNavigation(e, {
//                   name: "Our\u00A0Services",
//                   path: "/home",
//                   scrollTo: "services",
//                 })
//               }
//               className="relative inline-block group hover:text-teal-600"
//             >
//               Our&nbsp;Services
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>

//             <a
//               href="/home"
//               onClick={(e) =>
//                 handleNavigation(e, {
//                   name: "Our Products",
//                   path: "/home",
//                   scrollTo: "products",
//                 })
//               }
//               className="relative inline-block group hover:text-teal-600"
//             >
//               Our&nbsp;Products
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>

//             <a
//               href="/home"
//               onClick={(e) =>
//                 handleNavigation(e, {
//                   name: "How It Works",
//                   path: "/home",
//                   scrollTo: "how-it-works",
//                 })
//               }
//               className="relative inline-block group hover:text-teal-600"
//             >
//               How&nbsp;It&nbsp;Works
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>

//             <a
//               href="/home"
//               onClick={(e) =>
//                 handleNavigation(e, {
//                   name: "About Us",
//                   path: "/home",
//                   scrollTo: "about-us",
//                 })
//               }
//               className="relative inline-block group hover:text-teal-600"
//             >
//               About&nbsp;Us
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>

//             <button
//               onClick={(e) =>
//                 handleNavigation(e, {
//                   name: "Contact Us",
//                   path: "",
//                   scrollTo: "contact-us",
//                 })
//               }
//               className="relative inline-block group hover:text-teal-600"
//             >
//               Contact&nbsp;Us
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </button>

//             <a
//               href="/blogs"
//               onClick={(e) =>
//                 handleNavigation(e, {
//                   name: "Blogs",
//                   path: "/blogs",
//                   scrollTo: "/blogs",
//                 })
//               }
//               className="relative inline-block group hover:text-teal-600"
//             >
//               Blogs
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>
//           </div>
//         </div>

//         {/* Right Buttons */}
//         <div className="flex items-center justify-end gap-3 text-sm">
//           <div className="hidden lg:block">
//             <button className="relative inline-block group" onClick={openForm1}>
//               Estimate Project
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </button>
//           </div>

//           <button
//             onClick={toggleTheme}
//             className="p-2 rounded-full bg-white/40 dark:bg-black/40 transition"
//           >
//             {theme === "dark" ? (
//               <Sun className="w-5 h-5 text-gray-100" />
//             ) : (
//               <Moon className="w-5 h-5 text-black" />
//             )}
//           </button>

//           {/* Mobile Menu Icon */}
//           <div className="lg:hidden">
//             <button
//               onClick={toggleMenu}
//               className="relative z-[60] w-6 h-5 flex flex-col justify-between items-center focus:outline-none text-black dark:text-white"
//             >
//               <span
//                 className={`block h-[3px] w-full bg-current rounded transition-all duration-300 ${
//                   menuOpen ? "rotate-45 translate-y-[8.5px]" : ""
//                 }`}
//               ></span>
//               <span
//                 className={`block h-[3px] w-full bg-current rounded transition-all duration-300 ${
//                   menuOpen ? "opacity-0" : "opacity-100"
//                 }`}
//               ></span>
//               <span
//                 className={`block h-[3px] w-full bg-current rounded transition-all duration-300 ${
//                   menuOpen ? "-rotate-45 -translate-y-[8.5px]" : ""
//                 }`}
//               ></span>
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Mobile Side Menu */}
//       <div
//         className={`fixed top-0 right-0 h-full w-52 bg-white dark:bg-black text-black dark:text-white shadow-lg transform transition-transform duration-300 z-40
//         ${menuOpen ? "translate-x-0" : "translate-x-full"}`}
//       >
//         <nav className="flex flex-col p-6 space-y-8 mt-24">
//           <div>
//             <a
//               href="/"
//               onClick={(e) => {
//                 handleNavigation(e, {
//                   name: "Home",
//                   path: "/",
//                   scrollTo: "home",
//                 });
//                 setMenuOpen(false);
//               }}
//               className="relative inline-block group hover:text-teal-600"
//             >
//               Home
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>
//           </div>

//           <div>
//             <a
//               href="/home"
//               onClick={(e) => {
//                 handleNavigation(e, {
//                   name: "Our Services",
//                   path: "/home",
//                   scrollTo: "services",
//                 });
//                 setMenuOpen(false);
//               }}
//               className="relative inline-block group hover:text-teal-600"
//             >
//               Our Services
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>
//           </div>

//           <div>
//             <a
//               href="/home"
//               onClick={(e) => {
//                 handleNavigation(e, {
//                   name: "Our Products",
//                   path: "/home",
//                   scrollTo: "products",
//                 });
//                 setMenuOpen(false);
//               }}
//               className="relative inline-block group hover:text-teal-600"
//             >
//               Our Products
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>
//           </div>

//           <div>
//             <a
//               href="/home"
//               onClick={(e) => {
//                 handleNavigation(e, {
//                   name: "How It Works",
//                   path: "/home",
//                   scrollTo: "how-it-works",
//                 });
//                 setMenuOpen(false);
//               }}
//               className="relative inline-block group hover:text-teal-600"
//             >
//               How It Works
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>
//           </div>

//           <div>
//             <a
//               href="/home"
//               onClick={(e) => {
//                 handleNavigation(e, {
//                   name: "About Us",
//                   path: "/home",
//                   scrollTo: "about-us",
//                 });
//                 setMenuOpen(false);
//               }}
//               className="relative inline-block group hover:text-teal-600"
//             >
//               About Us
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>
//           </div>

//           <div>
//             <button
//               onClick={(e) => {
//                 handleNavigation(e, {
//                   name: "Contact Us",
//                   path: "",
//                   scrollTo: "contact-us",
//                 });
//                 setMenuOpen(false);
//               }}
//               className="relative inline-block group hover:text-teal-600"
//             >
//               Contact Us
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </button>
//           </div>

//           <div>
//             <a
//               href="/blogs"
//               onClick={(e) => {
//                 handleNavigation(e, {
//                   name: "Blogs",
//                   path: "/blogs",
//                   scrollTo: "/blogs",
//                 });
//                 setMenuOpen(false);
//               }}
//               className="relative inline-block group hover:text-teal-600"
//             >
//               Blogs
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </a>
//           </div>

//           <div>
//             <button
//               className="relative inline-block group text-teal-600"
//               onClick={openForm1}
//             >
//               Estimate Project
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </button>
//           </div>
//         </nav>
//       </div>

//       {/* Overlay when mobile menu is open */}
//       {menuOpen && (
//         <div
//           onClick={toggleMenu}
//           className="fixed inset-0 bg-black/40 z-30 transition-opacity duration-300"
//         ></div>
//       )}

//       {/* Schedule Meeting Popup */}
//       {IsFormOpenFor_bookCall && (
//         <>
//           {/* Overlay */}
//           <div
//             className="fixed inset-0 bg-black/60 z-20"
//             onClick={closeForm1}
//           ></div>

//           {/* Popup Container */}
//           <div className="fixed left-1/2 top-24 -translate-x-1/2 max-h-[80vh] h-auto w-[90%] sm:w-auto bg-white rounded-lg shadow-2xl z-30 p-5 sm:p-8">
//             {/* Close Button */}
//             <button
//               className="absolute top-1 right-3 text-3xl bg-white rounded-full text-gray-700 hover:text-teal-600 transition duration-200"
//               onClick={closeForm1}
//               aria-label="Close"
//             >
//               &times;
//             </button>

//             {/* Form */}
//             <form>
//               <div className="mt-0 max-h-[70vh] overflow-hidden">
//                 <InlineWidget
//                   url="https://calendly.com/contact-inittechnology/30min"
//                   rootElement={document.getElementById("root")}
//                   text="Book a Call"
//                   textColor="#ffffff"
//                   color="rgb(31, 151, 151)"
//                   // styles={{
//                   //   height: "70vh",
//                   // }}
//                 />
//               </div>
//             </form>
//           </div>
//         </>

//         // <>
//         //   <div
//         //     className="block fixed h-screen w-screen bg-black opacity-60 z-20"
//         //     onClick={closeForm1}
//         //   ></div>
//         //   <div className="fixed left-1/2 -translate-x-1/2 max-w-[320px] sm:min-w-full max-h-[80vh] mt-[15vh] z-30 overflow-hidden">
//         //     <span
//         //       className="absolute left-96 top-20 cursor-pointer text-2xl text-black"
//         //       onClick={closeForm1}
//         //     >
//         //       &times;
//         //     </span>
//         //     <form>
//         //       <div>
//         //         {/* <p className="hidden lg:block text-black absolute lg:m-3 uppercase">
//         //               Schedule a meeting to estimate project
//         //             </p> */}
//         //         <InlineWidget
//         //           url="https://calendly.com/contact-inittechnology/30min"
//         //           rootElement={document.getElementById("root")}
//         //           text="Book a Call"
//         //           textColor="#ffffff"
//         //           color="rgb(31, 151, 151)"
//         //         />
//         //       </div>
//         //     </form>
//         //   </div>
//         // </>
//       )}

//       {/* INIT Chatbot */}
//       <ChatBot />
//     </>
//   );
// };

// export default Header;

import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  Suspense,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Sun, Moon } from "lucide-react";

// lazy ChatBot
const LazyChatBot = React.lazy(() => import("./ChatBot"));

const Header = () => {
  const [theme, setTheme] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuOpenRef = useRef(menuOpen);
  const location = useLocation();
  const navigate = useNavigate();

  const isHome = location.pathname === "/" || location.pathname === "/Home";

  // keep ref in sync
  useEffect(() => {
    menuOpenRef.current = menuOpen;
  }, [menuOpen]);

  // Initialize theme (once)
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setTheme(savedTheme);
      document.documentElement.classList.toggle("dark", savedTheme === "dark");
    } else {
      const prefersDark = window.matchMedia(
        "(prefers-color-scheme: dark)",
      ).matches;
      const initial = prefersDark ? "dark" : "light";
      setTheme(initial);
      document.documentElement.classList.toggle("dark", prefersDark);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // disable scroll when menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
  }, [menuOpen]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => {
      const newTheme = prev === "dark" ? "light" : "dark";
      localStorage.setItem("theme", newTheme);
      document.documentElement.classList.toggle("dark", newTheme === "dark");
      return newTheme;
    });
  }, []);

  const toggleMenu = useCallback(() => setMenuOpen((p) => !p), []);

  // Close menu on resize — only set state if it was open to avoid no-op updates
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024 && menuOpenRef.current) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavigation = useCallback(
    (e, item) => {
      if (e && typeof e.preventDefault === "function") e.preventDefault();

      if (item.name === "Contact Us") {
        const t = document.getElementById("contact-us");
        if (t) {
          t.scrollIntoView({ behavior: "smooth" });
        } else {
          navigate("/", { state: { scrollTo: "contact-us" } });
        }
        setMenuOpen(false);
        return;
      }

      if (item.name === "Blogs") {
        if (location.pathname === "/" || location.pathname === "/home") {
          const tgt = document.getElementById("blogs");
          if (tgt) tgt.scrollIntoView({ behavior: "smooth" });
        } else {
          navigate("/blogs");
        }
        setMenuOpen(false);
        return;
      }

      if (location.pathname === "/" || location.pathname === "/home") {
        const tgt = document.getElementById(item.scrollTo);
        if (tgt) tgt.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate("/", { state: { scrollTo: item.scrollTo } });
      }
      setMenuOpen(false);
    },
    [location.pathname, navigate],
  );

  // scroll-once guard
  const scrolledKeyRef = useRef(null);
  useEffect(() => {
    const scrollToId = location.state?.scrollTo;
    if (!scrollToId) return;

    const key = `${location.pathname}::${scrollToId}`;
    if (scrolledKeyRef.current === key) return;
    scrolledKeyRef.current = key;

    const timer = setTimeout(() => {
      const el = document.getElementById(scrollToId);
      if (el) el.scrollIntoView({ behavior: "smooth" });
      // clear state without causing effect to re-run (we already guard by scrolledKeyRef)
      try {
        window.history.replaceState({}, document.title, location.pathname);
      } catch {
        // fallback
        navigate(location.pathname, { replace: true, state: {} });
      }
    }, 350);

    return () => clearTimeout(timer);
  }, [location.pathname, location.state, navigate]);

  // Calendly lazy import only when popup actually opens (not mounted by default)
  const [IsFormOpenFor_bookCall, setIsFormOpenFor_bookCall] = useState(false);
  const [CalendlyWidget, setCalendlyWidget] = useState(null);

  useEffect(() => {
    if (!IsFormOpenFor_bookCall || CalendlyWidget) return;
    let mounted = true;
    import("react-calendly")
      .then((mod) => {
        if (mounted && mod && mod.InlineWidget)
          setCalendlyWidget(() => mod.InlineWidget);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, [IsFormOpenFor_bookCall, CalendlyWidget]);

  const openForm1 = useCallback(() => {
    setIsFormOpenFor_bookCall(true);
    setMenuOpen(false);
  }, []);

  const closeForm1 = useCallback(() => setIsFormOpenFor_bookCall(false), []);

  return (
    <>
      <header
        className={`grid grid-cols-2 lg:grid-cols-[20%_50%_20%] items-center justify-between px-5 h-16
      ${
        isHome
          ? "bg-white/10 dark:bg-black/20"
          : "bg-white/80 dark:bg-black/90 shadow-newcustom"
      }
      border border-transparent dark:border-transparent 
      text-black dark:text-white transition-colors duration-300 fixed top-3 left-5 right-5 z-50 rounded-xl
      ${
        !menuOpen
          ? "shadow-custom dark:shadow-white border border-white/20 dark:border-white/10 backdrop-blur-sm"
          : "shadow-none"
      }`}
      >
        {/* <header
        className={`grid grid-cols-2 lg:grid-cols-[20%_50%_20%] items-center justify-between px-5 h-16
        bg-white/10 dark:bg-black/20 backdrop-blur-sm border border-transparent dark:border-transparent
        text-black dark:text-white transition-colors duration-300 fixed top-5 left-5 right-5 z-50 rounded-xl
        ${
          !menuOpen
            ? "shadow-custom dark:shadow-white border border-white/20 dark:border-white/10"
            : ""
        }`}
      > */}
        <button
          onClick={() => navigate("/")}
          className="flex items-center bg-transparent border-none p-0"
          aria-label="Go home"
        >
          <img
            src={
              theme === "light"
                ? "../assets/init_logoBlack.webp" // init_logoBlack.webp
                : "../assets/init_logoWhite.webp" // init_logoWhite.webp
            }
            alt="Logo"
            loading="lazy"
            className="h-11"
          />
        </button>

        <div className="hidden lg:block">
          <div className="flex justify-center text-sm space-x-5 xl:space-x-7">
            <button
              onClick={(e) =>
                handleNavigation(e, {
                  name: "Home",
                  path: "/",
                  scrollTo: "home",
                })
              }
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              Home
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>

            <button
              onClick={(e) =>
                handleNavigation(e, {
                  name: "Our Services",
                  path: "/home",
                  scrollTo: "services",
                })
              }
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              Our&nbsp;Services
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>

            <button
              onClick={(e) =>
                handleNavigation(e, {
                  name: "Our Products",
                  path: "/home",
                  scrollTo: "products",
                })
              }
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              Our&nbsp;Products
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>

            <button
              onClick={(e) =>
                handleNavigation(e, {
                  name: "How It Works",
                  path: "/home",
                  scrollTo: "how-it-works",
                })
              }
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              How&nbsp;It&nbsp;Works
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>

            <button
              onClick={(e) =>
                handleNavigation(e, {
                  name: "About Us",
                  path: "/home",
                  scrollTo: "about-us",
                })
              }
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              About&nbsp;Us
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>

            <button
              onClick={(e) =>
                handleNavigation(e, {
                  name: "Contact Us",
                  path: "",
                  scrollTo: "contact-us",
                })
              }
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              Contact&nbsp;Us
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>

            <button
              onClick={(e) =>
                handleNavigation(e, {
                  name: "Blogs",
                  path: "/blogs",
                  scrollTo: "/blogs",
                })
              }
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              Blogs
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 text-sm">
          <div className="hidden lg:block">
            <button className="relative inline-block group" onClick={openForm1}>
              Estimate Project
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>
          </div>

          <button
            onClick={toggleTheme}
            className="p-2 rounded-full bg-white/40 dark:bg-black/40 transition"
            aria-label="Toggle theme"
          >
            {theme === "dark" ? (
              <Sun className="w-5 h-5 text-gray-100" />
            ) : (
              <Moon className="w-5 h-5 text-black" />
            )}
          </button>

          <div className="lg:hidden">
            <button
              onClick={toggleMenu}
              className="relative z-[60] w-6 h-5 flex flex-col justify-between items-center focus:outline-none text-black dark:text-white"
              aria-label="Toggle menu"
            >
              <span
                className={`block h-[3px] w-full bg-current rounded transition-all duration-300 ${
                  menuOpen ? "rotate-45 translate-y-[8.5px]" : ""
                }`}
              />
              <span
                className={`block h-[3px] w-full bg-current rounded transition-all duration-300 ${
                  menuOpen ? "opacity-0" : "opacity-100"
                }`}
              />
              <span
                className={`block h-[3px] w-full bg-current rounded transition-all duration-300 ${
                  menuOpen ? "-rotate-45 -translate-y-[8.5px]" : ""
                }`}
              />
            </button>
          </div>
        </div>
      </header>

      {/* mobile menu */}
      <div
        className={`fixed top-0 right-0 h-full w-52 bg-white dark:bg-black text-black dark:text-white shadow-lg transform transition-transform duration-300 z-40 ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <nav className="flex flex-col p-6 space-y-8 mt-24">
          <div>
            <button
              onClick={(e) => {
                handleNavigation(e, {
                  name: "Home",
                  path: "/",
                  scrollTo: "home",
                });
                setMenuOpen(false);
              }}
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              Home
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>
          </div>

          <div>
            <button
              onClick={(e) => {
                handleNavigation(e, {
                  name: "Our Services",
                  path: "/home",
                  scrollTo: "services",
                });
                setMenuOpen(false);
              }}
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              Our Services
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>
          </div>

          <div>
            <button
              onClick={(e) => {
                handleNavigation(e, {
                  name: "Our Products",
                  path: "/home",
                  scrollTo: "products",
                });
                setMenuOpen(false);
              }}
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              Our Products
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>
          </div>

          <div>
            <button
              onClick={(e) => {
                handleNavigation(e, {
                  name: "How It Works",
                  path: "/home",
                  scrollTo: "how-it-works",
                });
                setMenuOpen(false);
              }}
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              How It Works
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>
          </div>

          <div>
            <button
              onClick={(e) => {
                handleNavigation(e, {
                  name: "About Us",
                  path: "/home",
                  scrollTo: "about-us",
                });
                setMenuOpen(false);
              }}
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              About Us
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>
          </div>

          <div>
            <button
              onClick={(e) => {
                handleNavigation(e, {
                  name: "Contact Us",
                  path: "",
                  scrollTo: "contact-us",
                });
                setMenuOpen(false);
              }}
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              Contact Us
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>
          </div>

          <div>
            <button
              onClick={(e) => {
                handleNavigation(e, {
                  name: "Blogs",
                  path: "/blogs",
                  scrollTo: "/blogs",
                });
                setMenuOpen(false);
              }}
              className="relative inline-block group hover:text-teal-600 bg-transparent border-none"
            >
              Blogs
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>
          </div>

          <div>
            <button
              className="relative inline-block group text-teal-600 bg-transparent border-none"
              onClick={() => {
                setIsFormOpenFor_bookCall(true);
                setMenuOpen(false);
              }}
            >
              Estimate Project
              <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full" />
            </button>
          </div>
        </nav>
      </div>
      {menuOpen && (
        <div
          onClick={toggleMenu}
          className="fixed inset-0 bg-black/40 z-30 transition-opacity duration-300"
        />
      )}
      {IsFormOpenFor_bookCall && (
        <>
          <div
            className="fixed inset-0 bg-black/60 z-20"
            onClick={closeForm1}
          />
          <div className="fixed left-1/2 top-24 -translate-x-1/2 h-auto w-[90%] sm:w-auto bg-white rounded-lg shadow-2xl z-30 p-5 sm:p-8">
            <button
              className="absolute top-1 right-3 text-3xl bg-white rounded-full text-gray-700 hover:text-teal-600 transition duration-200"
              onClick={closeForm1}
              aria-label="Close"
            >
              &times;
            </button>
            <div className="mt-0 max-h-[70vh] overflow-hidden">
              {CalendlyWidget ? (
                <CalendlyWidget
                  url="https://calendly.com/contact-inittechnology/30min"
                  rootElement={document.getElementById("root")}
                  text="Book a Call"
                  textColor="#ffffff"
                  color="rgb(31, 151, 151)"
                />
              ) : (
                <div className="p-6 text-center">Loading...</div>
              )}
            </div>
          </div>
        </>
      )}
      <Suspense fallback={null}>
        <LazyChatBot />
      </Suspense>
    </>
  );
};

export default Header;

// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { Sun, Moon } from "lucide-react";

// const Header = () => {
//   const [theme, setTheme] = useState(null);
//   const [menuOpen, setMenuOpen] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const savedTheme = localStorage.getItem("theme");
//     if (savedTheme) {
//       setTheme(savedTheme);
//       document.documentElement.classList.toggle("dark", savedTheme === "dark");
//     } else {
//       const prefersDark = window.matchMedia(
//         "(prefers-color-scheme: dark)"
//       ).matches;
//       setTheme(prefersDark ? "dark" : "light");
//       document.documentElement.classList.toggle("dark", prefersDark);
//     }
//   }, []);

//   useEffect(() => {
//     if (menuOpen) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "";
//     }
//   }, [menuOpen]);

//   const toggleTheme = () => {
//     const newTheme = theme === "dark" ? "light" : "dark";
//     setTheme(newTheme);
//     localStorage.setItem("theme", newTheme);
//     document.documentElement.classList.toggle("dark", newTheme === "dark");
//   };

//   const toggleMenu = () => {
//     setMenuOpen((prev) => !prev);
//   };

//   const pages = [
//     { name: "Home", path: "/", scrollTo: "home" },
//     { name: "Our\u00A0Services", path: "/home", scrollTo: "services" },
//     { name: "Our\u00A0Products", path: "/home", scrollTo: "products" },
//     {
//       name: "How\u00A0It\u00A0Works",
//       path: "/home",
//       scrollTo: "how-it-works",
//     },
//     { name: "About\u00A0Us", path: "/home", scrollTo: "about-us" },
//     { name: "Contact\u00A0Us", path: "", scrollTo: "contact-us" },
//     { name: "Blogs", path: "/blogs", scrollTo: "/blogs" },
//   ];

//   const handleNavigation = (e, item) => {
//     e.preventDefault();

//     // Contact Us always scrolls if the element exists
//     if (item.name === "Contact Us") {
//       const target = document.getElementById("contact-us");
//       if (target) {
//         target.scrollIntoView({ behavior: "smooth" });
//       } else {
//         // fallback if the section isn't on this page
//         navigate("/", { state: { scrollTo: "contact-us" } });
//       }
//       setMenuOpen(false);
//       return;
//     }

//     if (item.name === "Blogs") {
//       if (location.pathname === "/" || location.pathname === "/home") {
//         const target = document.getElementById("blogs");
//         if (target) target.scrollIntoView({ behavior: "smooth" });
//       } else {
//         navigate("/blogs");
//       }
//       setMenuOpen(false);
//       return;
//     }

//     if (location.pathname === "/" || location.pathname === "/home") {
//       const target = document.getElementById(item.scrollTo);
//       if (target) target.scrollIntoView({ behavior: "smooth" });
//     } else {
//       navigate("/", { state: { scrollTo: item.scrollTo } });
//     }

//     setMenuOpen(false);
//   };

//   useEffect(() => {
//     if (location.state?.scrollTo) {
//       const sectionId = location.state.scrollTo;
//       setTimeout(() => {
//         const target = document.getElementById(sectionId);
//         if (target) target.scrollIntoView({ behavior: "smooth" });
//       }, 400);
//       window.history.replaceState({}, document.title);
//     }
//   }, [location]);

//   return (
//     <>
//       <header
//         className={`grid grid-cols-2 lg:grid-cols-[20%_50%_20%] items-center justify-between px-5 h-16
//         bg-white/10 dark:bg-black/20 backdrop-blur-sm border border-transparent dark:border-transparent
//         text-black dark:text-white transition-colors duration-300 fixed top-5 left-5 right-5 z-50 rounded-xl
//         ${
//           !menuOpen
//             ? "shadow-custom dark:shadow-white border border-white/20 dark:border-white/10"
//             : ""
//         }`}
//       >
//         <a href="/Home">
//           <img
//             src={
//               theme === "light"
//                 ? "../assets/init_logoBlack.png"
//                 : "../assets/init_logoWhite.png"
//             }
//             alt="Logo"
//             className="h-11"
//           />
//         </a>

//         <div className="hidden lg:block">
//           <div className="flex justify-center text-sm space-x-5 xl:space-x-7">
//             {pages.map((item) => {
//               const isContact = item.name === "Contact Us";
//               return isContact ? (
//                 <button
//                   key={item.name}
//                   onClick={(e) => handleNavigation(e, item)}
//                   className="relative inline-block group hover:text-teal-600 text-left w-full"
//                 >
//                   {item.name}
//                   <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//                 </button>
//               ) : (
//                 <a
//                   key={item.name}
//                   href={item.path}
//                   onClick={(e) => handleNavigation(e, item)}
//                   className="relative inline-block group hover:text-teal-600"
//                 >
//                   {item.name}
//                   <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//                 </a>
//               );
//             })}

//             {/* {pages.map((item) => (
//               <a
//                 key={item.name}
//                 href={item.name === "Contact Us" ? "#" : item.path}
//                 onClick={(e) => handleNavigation(e, item)}
//                 className="relative inline-block group hover:text-teal-600"
//               >
//                 {item.name}
//                 <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//               </a>
//             ))} */}
//           </div>
//         </div>

//         <div className="flex items-center justify-end gap-3 text-sm">
//           <div className="hidden lg:block">
//             <button className="relative inline-block group">
//               Estimate Project
//               <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//             </button>
//           </div>

//           <button
//             onClick={toggleTheme}
//             className="p-2 rounded-full bg-white/40 dark:bg-black/40 transition"
//           >
//             {theme === "dark" ? (
//               <Sun className="w-5 h-5 text-gray-100" />
//             ) : (
//               <Moon className="w-5 h-5 text-black" />
//             )}
//           </button>

//           {/* Mobile Menu Icon with animation */}
//           <div className="lg:hidden">
//             <button
//               onClick={toggleMenu}
//               className="relative z-[60] w-6 h-5 flex flex-col justify-between items-center focus:outline-none text-black dark:text-white"
//             >
//               <span
//                 className={`block h-[3px] w-full bg-current rounded transition-all duration-300 ${
//                   menuOpen ? "rotate-45 translate-y-[8.5px]" : ""
//                 }`}
//               ></span>
//               <span
//                 className={`block h-[3px] w-full bg-current rounded transition-all duration-300 ${
//                   menuOpen ? "opacity-0" : "opacity-100"
//                 }`}
//               ></span>
//               <span
//                 className={`block h-[3px] w-full bg-current rounded transition-all duration-300 ${
//                   menuOpen ? "-rotate-45 -translate-y-[8.5px]" : ""
//                 }`}
//               ></span>
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Side Menu */}
//       <div
//         className={`fixed top-0 right-0 h-full w-52 bg-white dark:bg-black text-black dark:text-white shadow-lg transform transition-transform duration-300 z-40
//           ${menuOpen ? "translate-x-0" : "translate-x-full"}`}
//       >
//         <nav className="flex flex-col p-6 space-y-8 mt-24">
//           {pages.map((item) => {
//             const isContact = item.name === "Contact Us";
//             return isContact ? (
//               <button
//                 key={item.name}
//                 onClick={(e) => handleNavigation(e, item)}
//                 className="relative inline-block group hover:text-teal-600 text-left w-full"
//               >
//                 {item.name}
//                 <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//               </button>
//             ) : (
//               <a
//                 key={item.name}
//                 href={item.path}
//                 onClick={(e) => handleNavigation(e, item)}
//                 className="relative inline-block group hover:text-teal-600"
//               >
//                 {item.name}
//                 <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//               </a>
//             );
//           })}

//           {/* {pages.map((item) => (
//             <div>
//               <a
//                 key={item.name}
//                 href={item.name === "Contact Us" ? "#" : item.path}
//                 className="relative inline-block group hover:text-teal-600"
//                 // onClick={() => setMenuOpen(false)}
//                 onClick={(e) => {
//                   handleNavigation(e, item);
//                   setMenuOpen(false);
//                 }}
//               >
//                 {item.name}
//                 <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//               </a>
//             </div>
//           ))} */}
//         </nav>
//       </div>

//       {menuOpen && (
//         <div
//           onClick={toggleMenu}
//           className="fixed inset-0 bg-black/40 z-30 transition-opacity duration-300"
//         ></div>
//       )}
//     </>
//   );
// };

// export default Header;

// import React, { useEffect, useState } from "react";
// import { Sun, Moon } from "lucide-react";

// const Header = () => {
//   const [theme, setTheme] = useState(null);

//   useEffect(() => {
//     const savedTheme = localStorage.getItem("theme");

//     if (savedTheme) {
//       setTheme(savedTheme);
//       document.documentElement.classList.toggle("dark", savedTheme === "dark");
//     } else {
//       const prefersDark = window.matchMedia(
//         "(prefers-color-scheme: dark)"
//       ).matches;
//       setTheme(prefersDark ? "dark" : "light");
//       document.documentElement.classList.toggle("dark", prefersDark);
//     }
//   }, []);

//   const toggleTheme = () => {
//     const newTheme = theme === "dark" ? "light" : "dark";
//     setTheme(newTheme);
//     localStorage.setItem("theme", newTheme);
//     document.documentElement.classList.toggle("dark", newTheme === "dark");
//   };

//   return (
//     <header
//       className="grid grid-cols-2 lg:grid-cols-[20%_50%_20%] items-center justify-between px-5 h-20
//         bg-white/10 dark:bg-black/20 backdrop-blur-md shadow-custom dark:shadow-white border border-white/20 dark:border-white/10
//         text-black dark:text-white transition-colors duration-300 fixed top-5 left-5 right-5 z-50 rounded-xl"
//     >
//       <a href="/Home">
//         <img
//           src={
//             theme === "light"
//               ? "../assets/init_logoBlack.png"
//               : "../assets/init_logoWhite.png"
//           }
//           alt="Logo"
//           className="h-12"
//         />
//       </a>
//       {/* init_logoBlack.png */} {/* init_logoWhite.png */}
//       <div className="hidden lg:block">
//         <div className="flex justify-center text-sm space-x-5 xl:space-x-7 transition-all duration-200 ease-in-out">
//           <a
//             href="/"
//             className="relative inline-block group hover:text-teal-600"
//           >
//             Home
//             <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//           </a>

//           <a
//             href="/"
//             className="relative inline-block group hover:text-teal-600"
//           >
//             Our&nbsp;Services
//             <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//           </a>

//           <a
//             href="/"
//             className="relative inline-block group hover:text-teal-600"
//           >
//             Our&nbsp;Products
//             <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//           </a>

//           <a
//             href="/"
//             className="relative inline-block group hover:text-teal-600"
//           >
//             How&nbsp;It&nbsp;Works
//             <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//           </a>

//           <a
//             href="/"
//             className="relative inline-block group hover:text-teal-600"
//           >
//             About&nbsp;Us
//             <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//           </a>

//           <a
//             href="/"
//             className="relative inline-block group hover:text-teal-600"
//           >
//             Contact&nbsp;Us
//             <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//           </a>

//           <a
//             href="/"
//             className="relative inline-block group hover:text-teal-600"
//           >
//             Blogs
//             <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//           </a>
//         </div>
//       </div>
//       <div className="flex items-center justify-end gap-3 text-sm">
//         <div className="hidden lg:block">
//           <button className="relative inline-block group">
//             Estimate Project
//             <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-current transition-all duration-300 group-hover:w-full"></span>
//           </button>
//         </div>

//         <button
//           onClick={toggleTheme}
//           className="p-2 rounded-full bg-white/40 dark:bg-black/40 transition"
//         >
//           {theme === "dark" ? (
//             <Sun className="w-5 h-5 text-gray-100" />
//           ) : (
//             <Moon className="w-5 h-5 text-black" />
//           )}
//         </button>

//         <div className="lg:hidden">mobile menu</div>
//       </div>
//     </header>
//   );
// };

// export default Header;
